import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

const ReportsMedia = () => {
  const [reportsData, setReportsData] = useState({
    annual_reports: [],
    books_and_magazines: [],
    newsletter: [],
    videos_audio: [],
    campus: []
  });

  useEffect(() => {
    // সরাসরি প্রোডাকশন ব্যাকঅ্যান্ড ইউআরএল
    const BASE_URL = "https://project.shamayitamath.in";

    fetch(`${BASE_URL}/api/fetch_samayita_reports`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((resData) => {
        // এপিআই-এর { status: true, data: { ... } } স্ট্রাকচার নিখুঁতভাবে হ্যান্ডেল করা হলো
        if (resData && resData.status === true && resData.data) {
          setReportsData({
            annual_reports: resData.data.annual_reports || [],
            books_and_magazines: resData.data.books_and_magazines || [],
            newsletter: resData.data.newsletter || [],
            videos_audio: resData.data.videos_audio || [],
            campus: resData.data.campus || []
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  }, []);

  // ইমেজ এবং পিডিএফ এর সঠিক ফুল ইউআরএল তৈরি করার হেল্পার ফাংশন
  const getFullAssetUrl = (path) => {
    if (!path) return "";
    // যদি ইতিমধ্যেই পূর্ণ ইউআরএল থাকে (http/https) তবে সেটাই রিটার্ন করবে
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    // নতুবা আগে ব্যাকঅ্যান্ড ডোমেন জুড়ে দেবে
    return `https://project.shamayitamath.in${path}`;
  };

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11
      ? `https://www.youtube.com/embed/${match[2]}`
      : url;
  };

  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-reports-media.jpg")' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-white">Reports & Media</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Main Section */}
      <section>
        <div className="container">
          <div className="row mt-n2-9">

            {/* Sidebar */}
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                
                {/* Annual Reports */}
                <div className="widget mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <h2 className="mb-4 h4">Annual Reports</h2>
                  {reportsData.annual_reports.map((report, index) => (
                    <div className="d-flex border-bottom mb-4 pb-4" key={report.id || index}>
                      <div className="flex-shrink-0 me-4">
                        <i className="fa-solid fa-file-pdf display-16 text-primary"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-0">
                          <a href={getFullAssetUrl(report.document_url || report.url)} target="_blank" rel="noreferrer">
                            Annual Report {index + 1}
                          </a>
                        </h6>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Donation Banner */}
                <div className="widget bg-img cover-background text-center rounded p-1-9 left-overlay-primary" data-overlay-dark="85" style={{ backgroundImage: 'url("/img/bg/bg-03.jpg")' }}>
                  <div className="z-index-3 position-relative">
                    <h3 className="text-white mb-1-9">Your kindness can change lives.</h3>
                    <Link to="/contact" className="btn-style3 white medium">Donate today</Link>
                  </div>
                </div>

              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              
              {/* Books Section */}
              <h2 className="mb-4 wow fadeInUp" data-wow-delay="100ms">Books and Magazines</h2>
              <div className="row mt-n1-9 mb-5">
                {reportsData.books_and_magazines.map((book, idx) => (
                  <div key={book.id || idx} className="col-sm-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <article className="card card-style04 rounded h-100">
                      <div className="blog-img position-relative overflow-hidden image-hover">
                        <img 
                          src={getFullAssetUrl(book.image_url || book.cover_image)} 
                          alt={book.title} 
                          className="rounded-top" 
                          style={{ width: '100%', height: '250px', objectFit: 'cover' }} 
                        />
                      </div>
                      <div className="card-body p-1-6 p-lg-2-3">
                        <h4 className="mb-0">
                          <a href={getFullAssetUrl(book.document_url || book.url)} target="_blank" rel="noopener noreferrer">
                            {book.title}
                          </a>
                        </h4>
                      </div>
                    </article>
                  </div>
                ))}
              </div>

              {/* Newsletter Section */}
              <h2 className="mb-4 wow fadeInUp mt-5" data-wow-delay="100ms">Newsletter</h2>
              <div className="row mt-n1-9 mb-5">
                {reportsData.newsletter.map((nl, idx) => (
                  <div key={nl.id || idx} className="col-sm-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <article className="card card-style04 rounded h-100">
                      <div className="blog-img position-relative overflow-hidden image-hover">
                        <img 
                          src={getFullAssetUrl(nl.image_url || nl.cover_image)} 
                          alt={nl.title} 
                          className="rounded-top" 
                          style={{ width: '100%', height: '250px', objectFit: 'cover' }} 
                        />
                      </div>
                      <div className="card-body p-1-6 p-lg-2-3">
                        <h4 className="mb-0">
                          <a href={getFullAssetUrl(nl.document_url || nl.url)} target="_blank" rel="noopener noreferrer">
                            {nl.title}
                          </a>
                        </h4>
                      </div>
                    </article>
                  </div>
                ))}
              </div>

              {/* Videos Section */}
              <h2 className="mb-4 wow fadeInUp mt-5" data-wow-delay="100ms">Videos & Audio</h2>
              <div className="row mt-n1-9">
                {reportsData.videos_audio.map((video, idx) => (
                  <div className="col-sm-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms" key={video.id || idx}>
                    <article className="card card-style04 rounded h-100">
                      <div className="blog-img position-relative overflow-hidden">
                        <iframe
                          width="100%"
                          height="210"
                          src={getYoutubeEmbedUrl(video.link)}
                          title={video.title}
                          allowFullScreen
                          style={{ border: 'none' }}
                        ></iframe>
                      </div>
                      <div className="card-body p-1-6 p-lg-2-3">
                        <h4 className="mb-3">{video.title}</h4>
                      </div>
                    </article>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
        
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default ReportsMedia;
